<template lang="pug">
  div
    div.step-title1 {{currentStep.title}}
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'StepTitle1',
  computed: {
    ...mapGetters(['currentStep'])
  }
}
</script>

<style scoped>
@import 'step-title1.scss';
</style>
